import React from "react";
import Input from "./Input";
import { BlueLink, YellowButton, UnfilledYellowButton } from "../buttons";
import { dummyClick, emptyFunction } from "../utilities";

const SignUpForm = ({
  emailValue,
  handleEmailChange,

  passwordValue,
  handlePasswordChange,

  repeatPasswordValue,
  handleRepeatPasswordChange,

  subscribeToEmailsValue,
  toggleSubscribeToEmails,

  onSubmitClick,

  tosPath,
  privacyPath,

  onKeyUp,
  errorMsg,
  t
}) => (
  <div>
    <p>
      <Input
        value={emailValue}
        type="email"
        name="email"
        placeholder={t.email}
        onChange={handleEmailChange}
        onKeyUp={onKeyUp}
        autoFocus
        required
      />
    </p>
    <p>
      <Input
        value={passwordValue}
        type="password"
        name="password"
        placeholder={t.password}
        onChange={handlePasswordChange}
        onKeyUp={onKeyUp}
        required
      />
    </p>
    <p>
      <Input
        value={repeatPasswordValue}
        type="password"
        name="repeat_password"
        placeholder={t.repeatPassword}
        onChange={handleRepeatPasswordChange}
        onKeyUp={onKeyUp}
        required
      />
    </p>
    <p className="tl">
      {errorMsg &&
        errorMsg.map((msg, i) => (
          <span className="red db t-pl3 lh-copy" key={i}>
            {msg}
          </span>
        ))}
    </p>
    <p className="tl w-90 t-center" onClick={toggleSubscribeToEmails}>
      <Input
        type="checkbox"
        name="subscribe_to_emails"
        className="t-mr1 w-auto"
        checked={subscribeToEmailsValue}
      />
      <label className="a-font-size-5 gray-2" htmlFor="subscribe_to_emails">
        {t.popInAndEmailMe}
      </label>
    </p>
    <p className="tl gray-2 a-font-size-5 t-ml1 t-pa2 t-pb3 lh-copy">
      {t.legalText1}&nbsp;
      <BlueLink
        path={tosPath}
        text={t.tosLink}
        className="a-font-size-5"
        target="_blank"
        onClick={emptyFunction}
      />
      &nbsp;{t.legalText2}&nbsp;
      <BlueLink
        path={privacyPath}
        text={t.privacyLink}
        className="a-font-size-5"
        target="_blank"
        onClick={emptyFunction}
      />
      .
    </p>

    <YellowButton
      text={t.createAccount}
      className="w-90 mw6 px3 py1"
      onClick={onSubmitClick}
    />
  </div>
);

export default SignUpForm;
